exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-Analysis-Chart-___style__wrapper___5yqiZ{max-width:1200px;margin:auto;padding-bottom:70px;position:relative}.src-components-Analysis-Chart-___style__wrapper___5yqiZ .ohlc-tooltip text>tspan:nth-of-type(2){fill:#a4a4a4;border:1px solid red;width:200px}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "src-components-Analysis-Chart-___style__wrapper___5yqiZ"
};